.avatar {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 50%;
  color: var(--color-avatar-text);
  font-weight: var(--font-weight-semibold);
  line-height: 1;
  user-select: none;
  vertical-align: middle;
}

.xs {
  width: 1.5rem;
  height: 1.5rem;
  font-size: 0.625rem;
}

.sm {
  width: 2rem;
  height: 2rem;
  font-size: var(--font-size-xs);
}

.md {
  width: 2.5rem;
  height: 2.5rem;
  font-size: var(--font-size-md);
}

.lg {
  width: 3.5rem;
  height: 3.5rem;
  font-size: var(--font-size-xl);
}

.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.initials {
  letter-spacing: 0.02em;
}

.group {
  display: inline-flex;
  align-items: center;
}

.groupItem {
  box-shadow: 0 0 0 2px var(--color-surface);
}

.groupItem + .groupItem {
  margin-left: -0.5rem;
}

.overflow {
  background-color: var(--color-neutral-bg);
  color: var(--color-neutral-fg);
}
